window.casino = window.casino || {};
const repos = window.casino.repos = window.casino.repos || {};

repos.seoGameInfoRepo = function () {
    const get = function (sifraIgre) {
        let url = 'api/seogameinfo?c=' + casino.config.guiCacheVerzija;
        url = url + '&sifraigre=' + sifraIgre; 

        return fetch(url, {
            method: 'GET',
        }).then(function (response) {
            return response.json();
        });
    };

    return {
        get: get,
    }
}();

